import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';

import PageHeader from 'common/components/PageHeader';
import Loading from 'core/Loading';
import { useVenueContext } from 'modules/venue/VenueContext';

import useBestOfWoltFeatureFlag from '../hooks/useBestOfWoltFeatureFlag';
import { useBestOfWoltRoutes } from '../hooks/useBestOfWoltRoutes';
import { useVenueInsightsPermissions } from '../hooks/useVenueInsightsPermissions';
import { IndexPage } from '../pages/IndexPage';

export const VenueBestOfWolt = () => {
  const { formatMessage } = useIntl();
  const venue = useVenueContext();
  const hasVenueInsightsPermission = useVenueInsightsPermissions(venue);

  const { isBestOfWoltEnabled, isLoading } = useBestOfWoltFeatureFlag({
    venueId: venue.id,
    venueCountry: venue.country,
    venueCity: venue.city,
  });

  const { featureLink } = useBestOfWoltRoutes();

  if (isLoading) {
    return <Loading />;
  }

  return isBestOfWoltEnabled && hasVenueInsightsPermission ? (
    <>
      <PageHeader title={formatMessage({ id: 'best-of-wolt.title' })} />
      <IndexPage venueId={venue.id} venueTimezone={venue.timezone} />
    </>
  ) : (
    <Redirect to={featureLink} />
  );
};
